<template>
    <div class="ado-summary">
        <div class="ado-summary__header">
            <h5 class="ado-summary__header-title">Summary</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <div v-if="summaryAlert" class="alert alert-warning">
                <i class="far fa-exclamation-circle"></i> Summary data could not be retrieved. <b>Please contact your
                    system administrator.</b>
            </div>
            <summary-assignments v-else :data="summaryData"></summary-assignments>
        </div>
    </div>
</template>

<script>
import SummaryAssignments from "../../components/Summary/Assignments/Assignments";

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'ado-admin-summary',
    components: {
        SummaryAssignments
    },
    data() {
        return {
            dataRefresh: '',
            summaryData: [],
            summaryAlert: false
        }
    },
    methods: {
        getSummaryData() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorQueueSummary&department=${DEPARTMENT}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Set data
                    if (json.result.match(/^OK/i)) {
                        that.summaryData = json.data;
                    } else {
                        that.summaryAlert = true;
                    }
                })
                .catch(function (error) {
                    that.summaryAlert = true;
                })
        }
    },
    created() {
        const that = this;

        // Get summary data
        this.getSummaryData();

        // Auto refresh
        this.dataRefresh = setInterval(function () {
            that.getSummaryData();
        }, 30000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.dataRefresh);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.dataRefresh);
    }
}
</script>

<style scoped>
.ado-summary__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.ado-summary__header-title {
    font-weight: 600;
    margin: 0;
}
</style>